<!-- Modal-Backdrop -->
<div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" (click)="close()">
  <!-- Modal-Box -->
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[85vh] flex flex-col m-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-base-300">
      <h3 class="text-lg font-bold">Filiale auswählen</h3>
      <button class="bm-btn bm-btn-sm bm-btn-ghost bm-btn-square" (click)="close()">✕</button>
    </div>

    <!-- Schnellfilter -->
    <div class="p-4 border-b border-base-300">
      <input
        type="text"
        class="bm-input w-full"
        placeholder="Suchen nach Nr., Name oder Adresse…"
        (input)="quickSearchChanged($event)"
      />
    </div>

    <!-- Grid -->
    <div class="flex-1 min-h-0 p-4">
      @if (isLoading()) {
        <p class="text-base-content/60">Lade Filialen…</p>
      } @else if (rowData().length === 0) {
        <p class="text-base-content/60">Keine Filialen im Projekt hinterlegt (Tab „Filialen").</p>
      } @else {
        <ag-grid-angular
          class="h-[55vh] w-full"
          [theme]="hawkTheme"
          [localeText]="locale"
          [rowData]="rowData()"
          [columnDefs]="colDefs"
          [defaultColDef]="defaultColDef"
          rowSelection="single"
          (gridReady)="onGridReady($event)"
          (rowClicked)="onRowClicked($event)"
        />
      }
    </div>
  </div>
</div>
